// extracted by mini-css-extract-plugin
export default {"container":"claim_container__PQg9E","close":"claim_close__dJoFy","right":"claim_right__HmJ6X","time":"claim_time__a84Mf"};